document.body.addEventListener("click", function (e) {
  const target = e.target.closest(".js-blog-next-page");
  if (target) {
    e.preventDefault();

    const href = target.getAttribute("data-href");
    const loadingText = target.getAttribute("data-loading-text");
    target.querySelector('span').innerHTML = loadingText;

    fetch(href)
      .then(response => response.text())
      .then(data => {
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = data;

        const blogAction = document.querySelector(".js-blog-action");
        if (blogAction) {
          blogAction.remove();
        }

        const newBlogContent = tempDiv.querySelector(".js-blog-row");
        const blogRow = document.querySelector(".js-blog-row");

        if (newBlogContent && blogRow) {
          blogRow.insertAdjacentHTML("beforeend", newBlogContent.innerHTML);
        }

        initializeFadeInObserver(document);
      });
  }
});

document.addEventListener('DOMContentLoaded', () => {
  const allDropdowns = document.querySelectorAll('.js-dropdown');
  let ignoreNextFocus = false;

  document.addEventListener('mousedown', (event) => {
    ignoreNextFocus = true;
    setTimeout(() => ignoreNextFocus = false, 100);
  });

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.js-open-dropdown');

    if (!button && !event.target.closest('.js-dropdown')) {
      allDropdowns.forEach(d => d.classList.remove('active'));
      return;
    }

    if (button) toggleDropdown(button);
  });

  document.addEventListener('focusin', (event) => {
    if (ignoreNextFocus) return;
    const button = event.target.closest('.js-open-dropdown');
    if (button) toggleDropdown(button);
  });

  function toggleDropdown(button) {
    const parent = button.parentElement;
    if (!parent) return;

    const dropdown = parent.querySelector('.js-dropdown');
    if (!dropdown) return;

    const isActive = dropdown.classList.contains('active');
    allDropdowns.forEach(d => d.classList.remove('active'));

    if (!isActive) dropdown.classList.add('active');
  }
});